import {Component, inject, OnInit} from '@angular/core';
import {ModelsUser} from "../../../app/api/model/models";
import {UsersService} from "../../../app/api/api/users.service";
import {ButtonModule} from "primeng/button";
import {TableModule} from "primeng/table";
import {PaginatorModule} from "primeng/paginator";
import {RippleModule} from "primeng/ripple";
import {ToolbarModule} from "primeng/toolbar";
import {InputTextModule} from "primeng/inputtext";
import {ConfirmationService, MessageService} from "primeng/api";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {ToastModule} from "primeng/toast";
import {HrEmployeesForm} from './hr.employees.form';
import {Card} from 'primeng/card';

@Component({
  selector: 'app-hr-employees',
  template: `
    <p-toast></p-toast>
    <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
    <app-hr-employee-form [visible]="employeeDialog" [employee]="employee" (onSave)="saveEmployee($event)"
                          (onCancel)="hideDialog()"></app-hr-employee-form>


    <p-card>
      @if(false) {
        <div class="flex justify-between mb-4">
          <div>
            <p-button label="Create" severity="success" icon="pi pi-plus" (click)="openNew()"/>
            <!--          <button pButton pRipple pButtonLabel="New" pButtonIcon="pi pi-plus" class="p-button-success mr-2" (click)="openNew()"></button>-->
            <!--          <button pButton pRipple pButtonLabel="Archive" pButtonIcon="pi pi-trash" class="p-button-danger" (click)="deleteSelectedEmployees()" [disabled]="!selectedEmployees || !selectedEmployees.length"></button>-->
          </div>
          <div>
            <!--          <button pButton pRipple label="Export" icon="pi pi-upload" class="p-button-help"></button>-->
          </div>
        </div>
      }
      <p-table
        #dt
        [value]="employees"
        [rows]="10"
        [paginator]="true"
        [rowsPerPageOptions]="[10, 20, 30]"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [(selection)]="selectedEmployees"
        selectionMode="multiple"
        [rowHover]="true"
        dataKey="id"
        tableStyleClass="mb-4">
        <!--      <ng-template pTemplate="caption">-->
        <!--        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">-->
        <!--          <span class="block mt-2 md:mt-0 p-input-icon-left">-->
        <!--            <i class="pi pi-search"></i>-->
        <!--            <input pInputText type="text" (input)="dt.filterGlobal($event.target?.value, 'contains')" placeholder="Search..." />-->
        <!--          </span>-->
        <!--        </div>-->
        <!--      </ng-template>-->
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="first_name">First Name
              <p-sortIcon field="first_name"></p-sortIcon>
            </th>
            <th pSortableColumn="last_name">Last Name
              <p-sortIcon field="last_name"></p-sortIcon>
            </th>
            <th pSortableColumn="phone">Phone
              <p-sortIcon field="phone"></p-sortIcon>
            </th>
            <th>
              Position
            </th>
<!--            <th></th>-->
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-employee>
          <tr>
            <td>{{ employee.first_name }}</td>
            <td>{{ employee.last_name }}</td>
            <td>{{ employee.phone }}</td>
            <td>{{ employee.positions && employee.positions.length > 0 ? employee.positions[0].name : '' }}</td>
<!--            <td class="w-0">-->
<!--              <div class="flex flex-row flex-nowrap">-->
<!--                <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2"-->
<!--                        (click)="editEmployee(employee)"></button>-->
<!--                <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning"-->
<!--                        (click)="deleteEmployee(employee)"></button>-->
<!--              </div>-->
<!--            </td>-->
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  `,
  standalone: true,
  imports: [
    ButtonModule,
    TableModule,
    PaginatorModule,
    RippleModule,
    ToolbarModule,
    InputTextModule,
    HrEmployeesForm,
    ConfirmDialogModule,
    ToastModule,
    Card
  ],
  providers: [MessageService, ConfirmationService]
})
export class HrEmployeesIndex implements OnInit {
  private usersApi = inject(UsersService);
  private messageService = inject(MessageService);
  private confirmationService = inject(ConfirmationService);

  employees: ModelsUser[] = [];
  selectedEmployees: ModelsUser[] = [];
  employeeDialog = false;
  employee: ModelsUser = {} as ModelsUser;

  ngOnInit() {
    this.usersApi.apiUsersGet().subscribe((r: any) => {
      if (r.data) {
        this.employees = r.data;
      }
    });
  }

  openNew() {
    this.employee = {} as ModelsUser;
    this.employeeDialog = true;
  }

  hideDialog() {
    this.employeeDialog = false;
  }

  saveEmployee(employee: ModelsUser) {
    const isNew = !employee.id;
    const mutation = isNew ? 'hr_createEmployee' : 'hr_updateEmployee';
    const variables = {
      hrEmployeeInput: {
        id: employee.id,
        first_name: employee.first_name,
        last_name: employee.last_name,
        phone: employee.phone
      }
    };
    // this.gql.query(
    //   //language=GraphQL
    //   `
    //     mutation ${mutation}($hrEmployeeInput: HrEmployeeInput!) {
    //       ${mutation}(hrEmployeeInput: $hrEmployeeInput) {
    //         id
    //         first_name
    //         last_name
    //         email
    //       }
    //     }
    //   `,
    //   variables
    // ).subscribe((r: IGQLResponse<{ [key: string]: IGQLUser }>) => {
    //   const savedEmployee = r.data[mutation];
    //   if (isNew) {
    //     this.employees.push(savedEmployee);
    //   } else {
    //     this.employees[this.findIndexById(employee.id.toString())] = savedEmployee;
    //   }
    //   this.employees = [...this.employees];
    //   this.employeeDialog = false;
    //   this.messageService.add({severity: 'success', summary: 'Successful', detail: 'Employee Saved', life: 3000});
    // });
  }

  deleteEmployee(employee: ModelsUser) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete ' + employee.first_name + ' ' + employee.last_name + '?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        // this.gql.query(
        //   //language=GraphQL
        //   `
        //     mutation deleteEmployee($id: ID!) {
        //       hr_deleteEmployee(id: $id)
        //     }
        //   `,
        //   {id: employee.id}
        // ).subscribe(() => {
        //   this.employees = this.employees.filter(val => val.id !== employee.id);
        //   this.employee = {} as IGQLUser;
        //   this.messageService.add({severity: 'success', summary: 'Successful', detail: 'Employee Deleted', life: 3000});
        // });
      }
    });
  }

  deleteSelectedEmployees() {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete the selected employees?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        const ids = this.selectedEmployees.map(u => u.id);
        // this.gql.query(
        //   //language=GraphQL
        //   `
        //     mutation deleteEmployees($ids: [ID!]!) {
        //       hr_deleteEmployees(ids: $ids)
        //     }
        //   `,
        //   {ids}
        // ).subscribe(() => {
        //   this.employees = this.employees.filter(val => !this.selectedEmployees.includes(val));
        //   this.selectedEmployees = [];
        //   this.messageService.add({severity: 'success', summary: 'Successful', detail: 'Employees Deleted', life: 3000});
        // });
      }
    });
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.employees.length; i++) {
      if (Number(this.employees[i].id).toString() === id) {
        index = i;
        break;
      }
    }
    return index;
  }

  editEmployee(employee: ModelsUser) {
    this.employee = {...employee};
    this.employeeDialog = true;
  }
}
